export default "493aeaa9c2e42a65.svg"